exports.getCacheBustedLink = (
  root = '/',
  filename = 'ajax',
  fileprefix = 'php'
) => {
  const cacheBuster = new Date().getTime();
  const returnString = `${root}${filename}${cacheBuster}.${fileprefix}`;
  return returnString;
};

exports.hideMessage = (id, classSuffix, reload, sttoClear, toAction) => {
  const msgContainer = $(id);
  msgContainer.slideUp('slow');
  msgContainer.removeClass('alert-danger alert-success');
  msgContainer.find('p:first-child').html('');
  msgContainer.find('p:last-child').html('');
  // clear
  if (sttoClear) {
    clearTimeout(toAction);
  }
  if (reload === 1) {
    window.location = window.location.href;
  }
};

exports.showMessage = (
  type = 'info',
  id = '#message-box',
  title = '',
  text = '',
  tout = 10000,
  callBack = ''
) => {
  let reload = 0;
  if (callBack === 'reloadpage') {
    reload = 1;
  }
  const classSuffix = type === 'error' ? 'danger' : 'success';
  const msgContainer = $(id);
  const duration = tout === 'wait' ? 2000000 : tout;
  msgContainer.removeClass('alert-danger alert-success');
  msgContainer.find('p:first-child').html(title);
  msgContainer.find('p:last-child').html(text);
  msgContainer.addClass(`alert-${classSuffix}`);
  msgContainer.slideDown();
  setTimeout(mySo => {
    const sttoClear = tout === 'wait';
    if (tout === 'wait') {
      const confirmButton = document.createElement('button');
      $(confirmButton).addClass('btn');
      $(confirmButton).addClass('btn-success');
      $(confirmButton).attr('id', 'confirm-me');
      $(confirmButton).text('Ok');
      msgContainer.append(confirmButton);
      $('body').on('click', '#confirm-me', () => {
        callBack();
      });
    }
    module.exports.hideMessage(id, classSuffix, reload, sttoClear, mySo);
  }, duration);
};

exports.standardMessage = (target, action, partnerId, success) => {
  checkSendPermissionsSimple(partnerId, "SMILE").then(permissions => {
    if (permissions.checkFailed === true) {
      exports.showMessage(
        "error",
        "#message-box",
        "",
        permissions.errorMessage,
        99999999
      );
      if (permissions.showPremium === true) {
        $('#message-box p:last-child')
          .append($('<br>'))
          .append($('<br>'))
          .append($('<div>').addClass('text-center').html(i8n.error.Become_premium_button))
      }
      return false;
    }

    const data = new FormData();

    data.append(
      "message",
      new Blob(
        [
          JSON.stringify({
            message: "",
            type: action
          })
        ],
        {
          type: "application/json"
        }
      )
    );

    fetch(`/api/v1/public/message-threads/${partnerId}`, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      body: data // body data type must match "Content-Type" header
    }).then(r => {
      success(r);
    });
  });
}



// WEBPACK FOOTER //
// ./src/main/javascripts/lib/helper_lib.js